import useTeamData from '../../../state/team/UseTeamData';

import useFacilityData from '@usas/ui-web/state/facility/UseFacilityData';

const useTeamFacilityAdd = () => {
  const { facilityState } = useFacilityData();
  const { teamState } = useTeamData();

  return {
    teamState,
    facilityState
  };
};

export default useTeamFacilityAdd;